export default {
    homeScreen : {
        startConversation: 'Avvia una richiesta',
        newConversationButton: 'CHIEDI AIUTO',
        newMessageButton: '+ Nuovo messaggio',
        allTopics: 'Tutti gli argomenti',
        allChatsButton: 'Vedi tutto',
        poweredBy: 'Creato da Richpanel',
        reOpenConversation: 'Riaprire conversazione',
        recentConversations: 'La tua richiesta',
        startAChat: 'Avvia una chat',
        noRecentConversations: 'Nessuna conversazione recente',
        noRecentOrders: 'Nessun ordine recente',
        haveAQuestion: "Hai una domanda o vuoi solo salutarci? Siamo qui per aiutarti",
        conversationClosed: `La conversazione è stata segnalata come chiusa. Se hai qualche domanda riguardo questo problema puoi riaprirla.`,
        retry: 'Riprovare',
        errorOccured: 'Si è verificato un errore durante l`elaborazione della richiesta.',
        successMessage: 'Abbiamo ricevuto la vostra richiesta e un membro del nostro team vi contattera a {email} a breve.',
        loadingMessage: 'Si prega di riprovare. Stiamo processando la vostra richiesta.',
        goHome: 'Ritornare',
        sendUsMessage: 'Mandaci un messaggio',
        endChat: "CHIUDI LA CHAT",
        goto: 'Vai a',
    },
    orderStatuses: {
        'completed': 'Completo',
        'pending': 'In sospeso',
        'on hold': 'In attesa',
        'processing': 'In processo',
        'cancelled': 'Cancellato',
        'fulfilled': 'Realizzato',
        'confirmed': 'Confermato',
    },

    loginScreen: {
        title: 'Accedi al centro di assistenza',
        titleForOrdersScreenForward: 'Accedi per visualizzare i tuoi ordini',
        userIdFieldTitle: "Il tuo indirizzo email o numero di telefono",
        userIdFieldPlaceHolder: "Inserisci il tuo indirizzo email o numero di telefono",
        sendCode: "INSERISCI",
        enterCode: 'Inserisci il codice che ti abbiamo inviato',
        enterTheCode: 'Inserisci il codice',
        notYourUserId: 'Non è la tuo {userIdType}?',
        userIdTypes: {
            'phone': 'numero',
            'email': 'email',
        },
        change: 'Cambiare',
        notReceivedCode: "Non hai ricevuto il codice?",
        resendCode: 'Invia nuovamente',
        in: 'in',
        verifyCode: 'Verifica',
        logout: 'Logout',
        orderNumberFieldTitle: 'Inserisci il tuo numero d`ordine per poterti aiutare',
        orderNumberFieldPlaceholder: 'Inserire numero d`ordine Ex: 1234',
        zipcodeFieldTitle: 'Codice d`avviamento postale',
        zipcodeFieldPlaceholder: 'Inserire il codice d`avviamento postale',
        emailFieldTitle: 'Email',
        emailFieldPlaceholder: 'Inserire email',
    },

    orderList : {
        reorder: 'RIORDINARE',
        getHelp: 'CHIEDI AIUTO',
        startNewConversation: '+ Nuovo messaggio',
        viewPreviousOrder:'VISUALIZZA I TUOI ORDINI',
        seeAll: 'Visualizza tutti',
        viewMoreOrders: 'VISUALIZZA ALTRI ORDINI',
        viewOrderStatus: 'VISUALIZZA LO STATO DELL`ORDINE',
        chatWithUs: 'CHATTA CON NOI',
        issueWithPreviousOrder:'AIUTO PER ORDINI PRECEDENTI' ,
        orderLabel: 'Ordine',
        help: 'Aiuto',
        lastOrder: 'Ultimo Ordine',
        selectRelevantItems: 'Selezionare gli articoli rilevanti',
        selectItemsErrorMsg: 'Si prega di selezionare gli articoli rilevanti',
        selectAll: 'Selezionare tutti',
        selectQuantity: 'Quanti articoli?',
        helpWithThisOrder: 'Aiuto per questo ordine',
        yourOrders: 'I Tuoi ordini',
        view: 'VISUALIZZARE',
        track: 'TRACCIARE',
        addressTitle: 'Sommario dell`Ordine',
        billingAddressTitle: 'INDIRIZZO DI FATTURAZIONE',
        shippingAddressTitle: 'INDIRIZZO DI SPEDIZIONE',
        receiptTitle: 'articoli',
        itemTotal: 'Totale',
        taxes: 'Tasse',
        discounts: 'Sconti', 
        giftCard: 'Gift Card', 
        deliveryCharges: 'Spese di Spedizione',
        total: 'Totale',
        loginToViewOrders: 'Cliente esistente?',
        loginSuggestion: "Ottieni aiuto e supporto per gli ordini rapidamente",
        trackingOrderLabel: 'Tracciare ordine',
        shipmentDescription: "Ritorna a questa pagina per gli aggiornamenti sullo stato della tua spedizione",
        free: "gratuito",
        selectedItems: "Articoli Selezionati",
        items: "Articoli",
        "orderSearchPlaceholder": 'Filtra per ordine n.',
        "noOrderFound": 'Nessun ordine corrispondente {orderId}',
    },
    chatListScreen: {
        header: 'Le tue Richieste',
    },
    sentences: {
        "IN_A_DAY" : "Solitamente rispondiamo entro un giorno.",
        "IN_FEW_MINUTES": "Solitamente rispindiamo entro pochi minuti.",
        "IN_FEW_HOURS": "Solitamente rispondiamo entro poche ore.",
        "AS_SOON_AS_THEY_CAN": "Il team vi risponderà appena possibile.",
        "BACK_ON": "Ritorneremo in",
        "BACK_IN": "Ritorneremo in",
        "HOURS": "Ore",
        "MINUTES": 'Minuti',
        provideBelowDetails: "Si prega di fornire i seguenti dettagli",
    },
    inputFields: {
        submitted: 'invato'
    },
    inputPropDisplayNames: {
        "email": "Email",
        "phone": "Telefono",
        "Phone": "Telefono",
        "firstName": "Nome",
        "lastName": "Cognome",
        "uid": "Id Utente",
        "campaign": "Campagna UTM",
        "medium": "Medio UTM",
        "googleplus": "Google plus",
        "shippingPhone": "Telefono per la Spedizione",
        "source": "UTM Fonte",
        "lastOrderAt": "Tempo Ultimo Ordine",
        "firstOrderAt": "Tempo Primo Ordine",
        "visits": "Sessioni",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Ultima Visualizzazione",
        "createdAt": "Prima Visualizzazione",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Indirizzo Email di Fatturazione",
        "billingPhone": "Numero di Telefono di Fatturazione",
        "shippingEmail": "Indirizzo Email di Spedizione",
        "state": "Stato",
        "city": "Città",
        "country": "Paese",
        "deviceType": "Tipo di Dispositivo",
        "browserName": "Browser utilizzato",
        "osName": "Nome Os",
        "platform": "piattaforma",
        "ltv": "CLV",
        "ordersCount": "Conteggio ordini",
        "name": "Nome",
        "RichpanelPredictedCLV": "CLV Previsto",
        "RichpanelAliveProbability": "Probabilità di Acquisto",
        "RichpanelNextOrderDate": "Prossima Data Ordine",
        "RichpanelPredictedOrderCount": "Conteggio Ordine Previsto",
        "aov": "AOV",
        "WebsiteURL":"URL del sito Web"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Sei già cliente?',
        YES_EXISITING_CUSTOMER: "Si Sono un cliente",
        NO_EXISITING_CUSTOMER: "No Non sono ancora un cliente",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Inserisci il tuo indirizzo email per poterti contattare",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Verrai notificato qui e tramite ({email}) quando risponderemo",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Verrai notificato qui quando risponderemo",
        LEAVE_YOUR_MESSAGE: "Lasciate un messaggio.",
        TEAM_WILL_BE_BACK_IN:"Il team ritornerà in {hours} ore",
        TEAM_WILL_BE_BACK_ON:"Il team ritornerà alle {availableAt}",
        FEW_MORE_DETAILS: "Grazie! Qualche dettaglio in più ci aiuterà ad assegnarti alla persona corretta",
    },
    initialForm: {
        heading: 'Si prega di inserire i propri dati per avviare la chat',
        startChat: 'Avvia chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Avvia una chat',
        startChat: 'Avvia chat',
        proceed: 'Procedere',
        canWeHelpWithAnythingElse: 'Possiamo aiutarti con qualcos`altro?',
        noThanks: "No grazie",
        yesContactSupport: "Chattare con il Supporto",
        contactSupport: "Contattare il Supporto",
        yes: 'sì',
        no: 'No',
    },
    rating: {
        askedHeader: 'Valuta la tua conversazione',
        successHeader: 'Hai valutato questa conversazione',
        thanksMessage: "Grazie per averci avvisato",
        placeholderForRatingFeedback: "Si prega di lasciare un feedback"
    },
    placeholders: {
        emojiSearch: 'Cerca Emojis',
        typeAMessage: 'Scrivere un messaggio',
        searchGifs: 'Cerca GIFs',
    },
    lastMessageText: {
        sentAGif: 'Invia GIF',
        sharedFile: 'Inviato un allegato',
        askedForQualificationDetails: 'Richiesto i dettagli della qualifica',
        askedForRating: 'Richiesto una valutazione',
        askedForFeedback: 'Richiesto un feedback',
        sharedOrderSummary: "Condiviso sommario ordine"
    },
    greetingAnimation: {
        weAreOnline: 'Siamo online',
        askUsAnything: 'Chiedici qualsiasi cosa',
        chatWithUs: 'Chatta con noi'
    },
    errorMessages: {
        enterEmailOrPhone:  "Inserisci email/numero di telefono",
        enterValidOrPhone: "Inserisci un'email/numero di telefono validi",
        userNotFound: "Non abbiamo trovato nessun utente con questo id",
        enterCode: 'Inserisci il codice di accesso',
        invalidCode: 'Codice non VALIDO'
    }
}